/* =============================================================================
   Plants by Frank — Winkelwagen
   Vangt het toevoegen aan de winkelwagen af en vult de cart-drawer.

   Let op: dit is de ENIGE handler die toevoegt. Dawn's product-form.js bindt
   óók een submit-handler op het product-form; die wordt hier in de capture-fase
   gestopt, anders belandt elk artikel dubbel in de winkelwagen.

   Niet te verwarren met assets/cart.js — dat is Dawn's eigen bestand voor het
   wijzigen en verwijderen van regels binnen de winkelwagen.
   ============================================================================= */

(function () {
  'use strict';

  var THRESHOLD = 5000; // €50 in cents

  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function addItem(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    }).then(function (r) { return r.json(); });
  }

  function changeItem(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  // ── Global backdrop (direct child of <body> — avoids section stacking contexts) ──

  function getBackdrop() {
    var el = document.getElementById('pbf-global-backdrop');
    if (!el) {
      el = document.createElement('div');
      el.id = 'pbf-global-backdrop';
      el.style.position = 'fixed';
      el.style.top = '0';
      el.style.left = '0';
      el.style.right = '0';
      el.style.bottom = '0';
      el.style.zIndex = '9989';
      el.style.background = 'rgba(24,25,21,0.52)';
      el.style.pointerEvents = 'none';
      el.style.opacity = '0';
      el.style.visibility = 'hidden';
      el.style.transition = 'opacity 0.35s ease';
      document.body.appendChild(el);
    }
    return el;
  }

  function showBackdrop() {
    var el = getBackdrop();
    el.style.opacity = '1';
    el.style.visibility = 'visible';
  }

  function hideBackdrop() {
    var el = getBackdrop();
    el.style.opacity = '0';
    el.style.visibility = 'hidden';
  }

  // ── Open / Close ────────────────────────────────────────────────────────────

  function open() {
    // Signal all other PBF drawers to close before opening this one
    document.dispatchEvent(new CustomEvent('pbf:drawer:before-open', { detail: { id: 'cart' } }));
    var drawer = document.getElementById('pbf-cart-drawer');
    var overlay = document.getElementById('pbf-cart-overlay');
    if (drawer) { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); }
    if (overlay) { overlay.classList.add('is-visible'); overlay.setAttribute('aria-hidden', 'false'); }
    document.body.classList.add('pbf-cart-open');
    showBackdrop();
  }

  function close() {
    var drawer = document.getElementById('pbf-cart-drawer');
    var overlay = document.getElementById('pbf-cart-overlay');
    if (drawer) { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); }
    if (overlay) { overlay.classList.remove('is-visible'); overlay.setAttribute('aria-hidden', 'true'); }
    document.body.classList.remove('pbf-cart-open');
    hideBackdrop();
  }

  // ── Render ──────────────────────────────────────────────────────────────────

  var truckSvg = '<svg class="pbf-shipping-bar__icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';
  var checkSvg = '<svg class="pbf-shipping-bar__icon pbf-shipping-bar__icon--check" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';

  function updateShippingBar(totalCents) {
    var bar = document.getElementById('pbf-shipping-bar');
    if (!bar) return;
    var remaining = Math.max(0, THRESHOLD - totalCents);
    var pct = Math.min(100, Math.round((totalCents / THRESHOLD) * 100));
    var isComplete = remaining === 0;
    var text = isComplete
      ? 'Je hebt <strong>gratis verzending</strong> verdiend!'
      : 'Nog <strong>' + money(remaining) + '</strong> voor gratis verzending';
    var trackGradient = isComplete
      ? 'background:linear-gradient(to right,#D4ADAF,#C18B91)'
      : 'background:linear-gradient(to right,#D4ADAF 0%,#C18B91 ' + pct + '%,#EDE8E0 ' + pct + '%)';
    bar.innerHTML =
      '<div class="pbf-shipping-bar__track" style="' + trackGradient + ';height:8px;width:100%;display:block;"></div>' +
      '<div class="pbf-shipping-bar__row">' +
        (isComplete ? checkSvg : truckSvg) +
        '<p class="pbf-shipping-bar__text' + (isComplete ? ' pbf-shipping-bar__text--success' : '') + '">' + text + '</p>' +
      '</div>';
    bar.style.display = '';
  }

  function imageUrl(src) {
    if (!src) return '';
    return src.replace(/(\.(jpg|jpeg|png|gif|webp))(\?|$)/i, '_150x$1$3');
  }

  function renderItems(items) {
    var container = document.getElementById('pbf-cart-items');
    var footer    = document.getElementById('pbf-cart-footer');
    var bar       = document.getElementById('pbf-shipping-bar');
    if (!container) return;

    var colHeader = document.getElementById('pbf-col-header');

    if (!items || items.length === 0) {
      container.innerHTML =
        '<div class="pbf-cart-empty">' +
          '<div class="pbf-cart-empty__icon">' +
            '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round">' +
              '<path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>' +
              '<line x1="3" y1="6" x2="21" y2="6"/>' +
              '<path d="M16 10a4 4 0 0 1-8 0"/>' +
            '</svg>' +
          '</div>' +
          '<h2 class="pbf-cart-empty__title">Je winkelwagen is leeg</h2>' +
          '<p class="pbf-cart-empty__sub">Voeg planten toe om te beginnen.</p>' +
          '<a href="/collections/all" class="pbf-btn pbf-cart-empty__cta">Bekijk het assortiment <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M12 5l7 7-7 7"/></svg></a>' +
        '</div>';
      if (footer) footer.style.display = 'none';
      if (bar) bar.style.display = 'none';
      if (colHeader) colHeader.style.display = 'none';
      return;
    }

    if (colHeader) colHeader.style.display = '';

    container.innerHTML = items.map(function (item) {
      var img = item.image
        ? '<img src="' + imageUrl(item.image) + '" alt="' + item.product_title.replace(/"/g, '&quot;') + '" class="pbf-item__img" loading="lazy" width="88" height="88">'
        : '<div class="pbf-item__img pbf-item__img--empty"></div>';

      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<p class="pbf-item__variant">' + item.variant_title + '</p>'
        : '';

      return (
        '<div class="pbf-item" id="pbf-item-' + item.key + '">' +
          '<div class="pbf-item__media"><a href="' + item.url + '" tabindex="-1">' + img + '</a></div>' +
          '<div class="pbf-item__details">' +
            '<a href="' + item.url + '" class="pbf-item__name">' + item.product_title + '</a>' +
            '<p class="pbf-item__unit-price">' + money(item.price) + '</p>' +
            variant +
            '<div class="pbf-item__bottom">' +
              '<div class="pbf-item__qty">' +
                '<button type="button" class="pbf-item__qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Minder">' +
                  '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
                '</button>' +
                '<span class="pbf-item__qty-num">' + item.quantity + '</span>' +
                '<button type="button" class="pbf-item__qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Meer">' +
                  '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
                '</button>' +
              '</div>' +
              '<button type="button" class="pbf-item__remove" data-key="' + item.key + '" aria-label="Verwijderen">' +
                '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>' +
              '</button>' +
            '</div>' +
          '</div>' +
          '<div class="pbf-item__total">' +
            '<span class="pbf-item__price">' + money(item.final_line_price) + '</span>' +
          '</div>' +
        '</div>'
      );
    }).join('');
  }

  function renderFooter(cart) {
    var footer  = document.getElementById('pbf-cart-footer');
    var totalEl = document.getElementById('pbf-cart-total');
    if (!footer) return;
    if (cart.item_count > 0) {
      footer.style.display = '';
      if (totalEl) totalEl.textContent = money(cart.total_price);
    } else {
      footer.style.display = 'none';
    }
  }

  function updateCartCount(count) {
    var iconBubble = document.getElementById('cart-icon-bubble');

    // Bij een lege cart op eerste load ontbreekt de badge in de DOM. Maak 'm
    // aan zodra er items zijn, zodat de teller direct zichtbaar wordt.
    if (iconBubble && count > 0 && !iconBubble.querySelector('.cart-count-bubble')) {
      var newBubble = document.createElement('div');
      newBubble.className = 'cart-count-bubble';
      var span = document.createElement('span');
      span.setAttribute('aria-hidden', 'true');
      newBubble.appendChild(span);
      iconBubble.appendChild(newBubble);
    }

    document.querySelectorAll('.cart-count-bubble').forEach(function (bubble) {
      if (count <= 0) {
        bubble.remove();
        return;
      }
      bubble.querySelectorAll('span:not(.visually-hidden)').forEach(function (span) {
        span.textContent = count < 100 ? count : '';
      });
    });

    if (iconBubble) {
      iconBubble.setAttribute('aria-label', 'Winkelwagen (' + count + ' items)');
    }
  }

  function renderCart(cart) {
    updateShippingBar(cart.total_price);
    renderItems(cart.items);
    renderFooter(cart);
    updateCartCount(cart.item_count);
  }

  // ── Event bindings ──────────────────────────────────────────────────────────

  function bindItemEvents() {
    var container = document.getElementById('pbf-cart-items');
    if (!container) return;

    container.addEventListener('click', function (e) {
      // Quantity buttons
      var qtyBtn = e.target.closest('.pbf-item__qty-btn[data-key]');
      if (qtyBtn) {
        var key = qtyBtn.dataset.key;
        var newQty = parseInt(qtyBtn.dataset.qty, 10);
        changeItem(key, newQty).then(function (cart) { renderCart(cart); });
        return;
      }

      // Remove button
      var removeBtn = e.target.closest('.pbf-item__remove[data-key]');
      if (removeBtn) {
        changeItem(removeBtn.dataset.key, 0).then(function (cart) { renderCart(cart); });
      }
    });
  }

  function interceptATC() {
    // Capture-fase + stopImmediatePropagation: pbf-cart is de ENIGE handler die
    // toevoegt. Dawn's product-form.js bindt óók een submit-handler op het
    // product-form die naar /cart/add POST — zonder dit zou elk item DUBBEL
    // worden toegevoegd (en bij "Afrekenen" reken je met dubbele hoeveelheid af).
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      e.stopImmediatePropagation();

      var variantInput = form.querySelector('[name="id"]');
      if (!variantInput) return;

      // Let op: de aantal-input staat BUITEN het <form> en is eraan gekoppeld
      // via het form="..."-attribuut (zie main-product.liquid en
      // featured-product.liquid). form.querySelector kijkt alleen naar
      // afstammelingen en vond hem dus nooit — waardoor elk artikel als 1 stuk
      // in de winkelwagen belandde. FormData volgt wel die koppeling, precies
      // zoals de browser bij een gewone submit zou doen.
      var qty = parseInt(new FormData(form).get('quantity'), 10);
      if (!qty || qty < 1) qty = 1;
      var submitBtn = form.querySelector('[type="submit"]');
      var buyNow = form.hasAttribute('data-buy-now');

      if (submitBtn) submitBtn.disabled = true;

      addItem(variantInput.value, qty)
        .then(function () {
          if (buyNow) {
            // Direct doorsturen naar de checkout i.p.v. de drawer openen.
            // Root-prefix meenemen zodat een eventuele locale/market-context
            // (bv. /en-eu/) behouden blijft; valt terug op /checkout.
            var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
            window.location.assign(root.replace(/\/$/, '') + '/checkout');
            return null;
          }
          return fetchCart();
        })
        .then(function (cart) {
          if (!cart) return; // buy-now: pagina navigeert al naar /checkout
          renderCart(cart);
          open();
        })
        .catch(function (err) { console.error('[PBF Cart] Add failed:', err); })
        .finally(function () { if (submitBtn && !buyNow) submitBtn.disabled = false; });
    }, true);
  }

  // ── Init ────────────────────────────────────────────────────────────────────

  function init() {
    // Cart icon → open drawer
    var cartIcon = document.getElementById('cart-icon-bubble');
    if (cartIcon) {
      cartIcon.addEventListener('click', function (e) {
        e.preventDefault();
        fetchCart().then(function (cart) { renderCart(cart); open(); });
      });
    }

    // Close button
    var closeBtn = document.getElementById('pbf-cart-close');
    if (closeBtn) closeBtn.addEventListener('click', close);

    // Overlay (transparant, als fallback)
    var overlay = document.getElementById('pbf-cart-overlay');
    if (overlay) overlay.addEventListener('click', close);

    // Klik buiten de drawer → sluiten (document-level, werkt altijd)
    document.addEventListener('click', function (e) {
      var drawer = document.getElementById('pbf-cart-drawer');
      var cartIcon = document.getElementById('cart-icon-bubble');
      if (!drawer || !drawer.classList.contains('is-open')) return;
      if (!drawer.contains(e.target) && (!cartIcon || !cartIcon.contains(e.target))) {
        close();
      }
    });

    // Escape
    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape') close();
    });

    bindItemEvents();
    interceptATC();

    // Close this drawer when another PBF drawer opens
    document.addEventListener('pbf:drawer:before-open', function (e) {
      if (e.detail.id !== 'cart') close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
